<div
  *ngIf="job$ | async as job"
  class="candidate-job container"
>
  <div class="candidate-job-item-head">
    <mojo-association-label
      [candidateId]="association.candidateId"
      [jobId]="job.id"
      [internal]="association.internal"
    >
    </mojo-association-label>

    <div class="action-menu">
      <a
        [routerLink]="['history', association.id]"
        [skipLocationChange]="true"
        routerLinkActive="active"
        class="application-history-trigger"
        data-cy="job-application-history-details"
        matTooltip="Application overview"
        matTooltipPosition="above"
      >
        <mat-icon svgIcon="application-history"></mat-icon>
      </a>
      <mojo-candidate-reject-dropdown [association]="association">
      </mojo-candidate-reject-dropdown>
    </div>
  </div>

  <div class="assigned-job-info">
    <ng-container *ngIf="company$ | async as company">
      <common-mojo-avatar
        *ngIf="company.logoId"
        [id]="company.logoId"
        [selectedPhotoShape]="avatarShapes.circle"
        [backgroundSize]="avatarSize"
      ></common-mojo-avatar>
    </ng-container>
    <div class="flex-grow-1 w-100">
      <div
        class="job-title"
        [routerLink]="['/jobs', 'job', job.id]"
        [title]="job.title"
      >
        {{ job.title }}
      </div>
      <span class="job-details">
        <p class="mr-2">
          <span
            *ngIf="company$ | async as company"
            class="mr-1"
          >
            {{ company.name }}
          </span>

          <span class="job-id">
            Job ID: {{ job.id }}
          </span>
        </p>
        <mojo-job-location
          class="mr-2"
          *ngIf="job.locations?.length> 0"
          [showTooltip]="false"
          [locations]="job.locations"
        >
        </mojo-job-location>
        <span class="d-flex mw-100 flex-wrap">
          <mojo-status
            class="job-status"
            [status]="job.status"
            [statusFilterType]="jobStatusFilterFeature$ | async"
          >
          </mojo-status>
          <div class="created-info">
            <p *ngIf="association.createdDate">
              {{ association.createdDate | daysPassed: true }}
            </p>
            <p
              class="created-by ml-1"
              *ngIf="!!association?.createdById"
            >
              by: {{ association?.createdByName }}
            </p>
          </div>
        </span>
      </span>
    </div>
  </div>

  <ng-container>
    <mojo-dynamic-progress
      (click)="$event.stopPropagation()"
      [association]="association"
      [isDirectApplicant]="(associationLabel$ | async) === directApplicant"
      [disableStepper]="isOnRejectedState$ | async"
      class="d-block d-xs-none"
    >
    </mojo-dynamic-progress>
  </ng-container>
</div>
